import { getUserId } from "../../userId";
import { store } from "../../store";
import { delayedPromise } from "../../delayedPromise";
import { NETWORK_WARNINGS_INACTIVE, NETWORK_WARNINGS_ACTIVE } from ".";

const userConsents = {
  policies: [
    {
      name: "Terms of Use",
      document: "/policies/TermsOfUse_v2_0.txt",
      consentProvided: true,
    },
    {
      name: "Privacy Policy",
      document: "/policies/PrivacyPolicy_v2_0.txt",
      consentProvided: true,
    },
  ],
  consents: [
    {
      name: "Use of biometrics for authentication",
      description:
        "I agree to the processing of my biometrics for the purpose of authentication by this application.",
      consentProvided: true,
    },
  ],
};

const userConsentRequest = {
  serviceId: window.location.href,
  appId: "Onboarding Web App",
  userId: getUserId(),
  production: process.env.NODE_ENV === "production",
  consents: JSON.stringify(userConsents),
};

/**
 * POST {gdprServiceHostname}/userConsents
 */
export const sendConsent = () => (dispatch) => {
  dispatch({ type: NETWORK_WARNINGS_ACTIVE });
  const { configuration } = store.getState();
  const controller = new AbortController();
  const signal = controller.signal;
  setTimeout(() => {
    controller.abort();
  }, process.env.REACT_APP_CLIENT_TIMEOUT || 30000);
  let promise;
  //GDPR server does not allow requests from developer machines due to CORS, therefore it is mocked in develop mode
  if (
    process.env.REACT_APP_MOCK_API === "true" ||
    process.env.NODE_ENV === "development"
  ) {
    promise = delayedPromise({ ok: true });
  } else {
    promise = fetch(`${configuration.gdprServiceHostname}/userConsents`, {
      method: "POST",
      body: JSON.stringify(userConsentRequest),
      signal,
      credentials: "same-origin",
      headers: new Headers({
        "Content-Type": "application/json",
      }),
    });
  }
  return promise.then((response) => {
    dispatch({ type: NETWORK_WARNINGS_INACTIVE });
    return response;
  });
};
